export const AssetType = {
  All: 'all',
  LongHeadline: 'long-headline',
  ShortHeadline: 'short-headline',
  Description: 'description',
  Image: 'image',
  Logo: 'logo',
  CallToAction: 'call-to-action',
  Video: 'video',
} as const;

export const AssetTypeString = {
  [AssetType.All]: _TL_('All'),
  [AssetType.LongHeadline]: _TL_('Long headline'),
  [AssetType.ShortHeadline]: _TL_('Short headline'),
  [AssetType.Description]: _TL_('Description'),
  [AssetType.Image]: _TL_('Image'),
  [AssetType.Logo]: _TL_('Logo'),
  [AssetType.CallToAction]: _TL_('Call to action'),
  [AssetType.Video]: _TL_('Video'),
} as const;

export const MAX_ASSET_CONTAINERS_IN_FILTER = 5;
